import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Avatar } from 'dsm-react-lib'
import { getUserInitials } from '../../utility/Utils'

const ProfileContainer = styled.div`
  display: flex;
  justify-content: start;
  margin-right: 1rem;

  img {
    margin-top: 1rem;
    margin-left: 1.2rem;
  }
`

const NameAndAppsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 16px 0px 0px 16px;
  margin-right: 1rem;
`
const NameText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 21px;
  line-height: 30px;
  color: var(--text-heading);
`

const AppsText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-decoration-line: underline;
  color: var(--color-info);

  a {
    color: var(--color-info);
  }
`

const WorkspaceProfileCard = ({ user, iframeAppsLength }) => {
  return (
    <>
      <div className="text-center">
        <ProfileContainer>
          <Avatar
            content={user?.profilePictureBase64Encoded || getUserInitials(user?.displayName)}
            {...(user?.profilePictureBase64Encoded
              ? { size: '68px' }
              : { bgColor: `light-secondary`, size: 'x-large', className: 'ml-1 mr-0' })}
          />
          <NameAndAppsContainer>
            <NameText>Hi {user?.name?.split(',')[1] || user?.givenName}!</NameText>
            {iframeAppsLength > 0 ? (
              <AppsText className="apps-open-tour">
                <Link
                  to={{
                    pathname: '/apps/work-browser',
                    state: { fromIframe: false }
                  }}
                  className="open-apps">
                  {iframeAppsLength} {iframeAppsLength === 1 ? 'app' : 'apps'} open
                </Link>
              </AppsText>
            ) : (
              <></>
            )}
          </NameAndAppsContainer>
        </ProfileContainer>

        <div className="d-flex justify-content-start">
          <Link
            to={{
              pathname: '/apps/work-browser',
              state: { fromIframe: false }
            }}></Link>
        </div>
      </div>
    </>
  )
}
export default WorkspaceProfileCard
